import { Button, Tabs, Loading, Tag, Tooltip, Modal } from '@sede-enterprise/shell-ds-react-framework'
import useGetEquipmentDetails from './hooks/useGetEquipmentDetails';
import { resultSentimentMap } from '../../util/constants';
import { InfoCircle } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';
import CancuiSensorDetails from './components/CancuiSensorDetails';
import { useState } from 'react';
import ZoneMarkupContent from './components/ZoneMarkupContent';

const zoneLabels = {
        'Zone1': 'Zone 1',
        'Zone2': 'Zone 2',
        'Zone3': 'Zone 3',
        'Zone4': 'Zone 4',
    };

const getZoneLabels = (sensor_id, susceptibilityStatus) => {
    // Return the label if it exists in the id string, otherwise return the original sensor_id
    const matchedLabel = Object.keys(zoneLabels).find(key => sensor_id.includes(key));
    const susceptibilityStatusLabel = susceptibilityStatus ? susceptibilityStatus : "CONDENSATE RISK"
    const tag = <Tag
                                sentiment={resultSentimentMap[susceptibilityStatusLabel]}
                                variant='outlined'
                                shape='round'
                            >
                                {susceptibilityStatusLabel}
                            </Tag>
    return <><div style={{padding: '0 10px'}}>{matchedLabel ? zoneLabels[matchedLabel] : sensor_id}</div>{tag}</>
}


const CancuiDetails = ({ match }) => {
    const [modalSubmitted, setModalSubmitted] = useState(false);
    const [openZoneMarkingsModal,setOpenZoneMarkingsModal] = useState(false);
    const [zoneMarkUpId, setZoneMarkUpId] = useState("");
    const { data: equipmentData, isLoading: equipmentLoading } = useGetEquipmentDetails(match.params.id, modalSubmitted);
    const equipmentName = equipmentData?.objs && equipmentData?.objs.length > 0 ? equipmentData.objs[0].equipment.name : ""
    const unitName = equipmentData?.objs && equipmentData?.objs.length > 0 ? equipmentData.objs[0].unit.name : ""
    const susceptibilityStatus = equipmentData?.overall_susceptibilityStatus ? equipmentData?.overall_susceptibilityStatus : "CONDENSATE RISK"
    return (
        <div className='parent-container'>
            <div className='content-container'>
                <div className='content-header cam-header'>
                    <div className='header-title'>
                        <h3>CAN-CUI</h3>
                    </div>
                </div>
                <div className='content-body'>
                    {equipmentLoading && <div className='loading-container'><Loading /></div>}
                    {!equipmentLoading && equipmentData.objs.length > 0 && <div className='content-header cancui-body-header'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{margin: '10px'}}>
                                <h3 style={{margin: '0px'}}>Unit - {unitName}</h3>
                                <h3 style={{margin: '0px'}}>Equipment - {equipmentName}</h3>
                            </div>
                            <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>Zone Markup</div>} trigger={
                                <Button style={{ marginLeft: '5px' }} size='small' variant='filled' iconOnly icon={<InfoCircle />} onClick={() => {
                                    setOpenZoneMarkingsModal(true);
                                    setZoneMarkUpId(equipmentName);
                                }} />
                            } />
                        </div>
                        {(susceptibilityStatus) && <div className='rating-container'>
                            <Tag
                                sentiment={resultSentimentMap[susceptibilityStatus]}
                                variant='outlined'
                                shape='round'
                            >
                                {susceptibilityStatus}
                            </Tag>
                            <Tooltip className='tooltip' placement='bottom' overlay={<div className='tooltip-content'>CAN-CUI RESULT</div>} trigger={
                                <Button size='xsmall' variant='transparent' iconOnly icon={<InfoCircle />} />
                            } />
                        </div>}

                    </div>}
                    
                    {!equipmentLoading && equipmentData.objs.length == 1 && <CancuiSensorDetails 
                        match={match} 
                        setModalSubmitted={setModalSubmitted} 
                        modalSubmitted={modalSubmitted} 
                        equipmentData={equipmentData.objs[0]} />}
                    {!equipmentLoading && equipmentData.objs.length > 1 && 
                        <Tabs id='sensor-details-screen-id-3' tabBarStyle={{
                            justifyContent: 'flex-start',
                            // paddingLeft: '5%',
                            borderBottom: '1px solid #E0E0E0',
                            marginBottom: '20px'
                        }}
                            defaultActiveKey={equipmentData.contributedBy}
                            items={equipmentData.objs.map((sensor) => ({
                                label: getZoneLabels(sensor.id, sensor.susceptibilityStatus),
                                key: sensor.id,
                                children: <CancuiSensorDetails
                                    match={match} 
                                    setModalSubmitted={setModalSubmitted} 
                                    modalSubmitted={modalSubmitted} 
                                    equipmentData={sensor} />
                            }))}
                        />
                    }
                </div>
            </div>
            <Modal
                size='large'
                className='zone-markup-modal'
                title="Zone Markup"
                open={openZoneMarkingsModal}
                onClose={() => {
                    setOpenZoneMarkingsModal(false);
                    setZoneMarkUpId("");
                }}
                footer={null}
            >
                <div>
                    <ZoneMarkupContent id={zoneMarkUpId} />
                </div>
            </Modal>
        </div>
    )
}

export default CancuiDetails